import classNames from 'classnames';

import { FormattedUnit } from '../../../../components/domainSpecific/measuringUnitsElements';
import { useWaypointLineStyles } from './WaypointLine.styles';

const WaypointLine = ({ distance, inputUnit }) => {
  const { styles } = useWaypointLineStyles();
  return (
    <div
      className={classNames(
        'waypoint-line-wrapper',
        styles.waypointLineWrapper
      )}
    >
      <i
        className={classNames(
          'far fa-circle',
          styles.waypointIcon,
          styles.waypointIconTop
        )}
      />
      <i
        className={classNames(
          'fas fa-dot-circle',
          styles.waypointIcon,
          styles.waypointIconBottom
        )}
      />
      <div className={styles.waypointLine}>
        <div className={styles.waypointBadge}>
          <FormattedUnit
            unitType="distance"
            value={distance}
            inputUnit={inputUnit}
          />
        </div>
      </div>
    </div>
  );
};

export default WaypointLine;
